import IActionType from '../interfaces/IActionType';
import * as actionTypes from './actionTypes';

export const salvarEhAcessoAdministrativo = (ehAcessoAdministrativo: boolean): IActionType<boolean> => {
  return {
    type: actionTypes.SALVAR_EH_ACESSO_ADMINISTRATIVO,
    state: ehAcessoAdministrativo
  };
};